module.exports = __webpack_public_path__ + "img/forest.bf6b4dd9.svg";